import AppLayout from '../../components/AppLayout';
import { formatCurrency } from '../regureStyles';
import usePolicyFunctions from './usePolicyFunctions';
import Header from './Header';
import Filter from './Filter';
import Table from './Table';
import Pagination from './Pagination';
import NewPolicyPanel from './NewPolicyPanel';
const formatCHF = formatCurrency;

// ─── Policies Screen ──────────────────────────────────────
const PoliciesScreen = () => {
  const {
    STATUS_OPTIONS,
    PRODUCT_OPTIONS,
    history,
    policies,
    loading,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    productFilter,
    setProductFilter,
    page,
    setPage,
    pageSize,
    setPageSize,
    showNew,
    setShowNew,
    handleCloseNew,
    handleCreated,
    filtered,
    paginated,
    totalPages,
  } = usePolicyFunctions();

  return (
    <AppLayout>
      {showNew && <NewPolicyPanel onClose={handleCloseNew} onCreated={handleCreated} />}
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* Header */}
        <Header setShowNew={setShowNew} policies={policies} />

        {/* Filters */}
        <Filter
          search={search}
          setSearch={setSearch}
          setPage={setPage}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          STATUS_OPTIONS={STATUS_OPTIONS}
          productFilter={productFilter}
          setProductFilter={setProductFilter}
          PRODUCT_OPTIONS={PRODUCT_OPTIONS}
          filtered={filtered}
        />

        {/* Table */}
        <Table history={history} loading={loading} paginated={paginated} formatCHF={formatCHF} />

        {/* Pagination */}
        <Pagination totalPages={totalPages} page={page} setPage={setPage} paginated={paginated} filtered={filtered} pageSize={pageSize} setPageSize={setPageSize} />
      </div>
    </AppLayout>
  );
};

export default PoliciesScreen;
